import { connect, ConnectedProps } from 'react-redux';

import DropContractPage from '../pages/DropContractPage';

import {
  IPropyCookieValue,
} from '../interfaces';

interface RootState {
  darkMode: boolean;
  consentToCookies: boolean;
  propyCookieValue: string;
}

const mapStateToProps = (state: RootState) => ({
  darkMode: state.darkMode,
  propyCookieValue: JSON.parse(state.propyCookieValue) as IPropyCookieValue,
})

const connector = connect(mapStateToProps, {})

export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(DropContractPage)